import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Input,
  Form,
  Row,
  message,
  Modal,
  Spin,
  Select,
  Image,
  notification
} from "antd";

import TicketSidebar from "../TicketSidebar";
import queryString from "query-string";
import APIClient from "../../../helpers/ApiClient";
import TicketFlight from "./TicketFlight";
import { shouldShowFlightTicketSidebar } from "../AllTicketStatus";
import dayjs from "dayjs";
import { formatDate, DISPLAY_FORMAT } from "../../../helpers/dateHelper";

import { OnlyFutureDateValidator } from "../../../helpers/CustomValidators";
import LogoImg from "../../../assets/images/logos/trip-logo.png";
import { LoadingOutlined, CloseOutlined } from "@ant-design/icons";
import { useAuthContext } from "../../providers/AuthProvider";
import { useSytContext } from "../../providers/SytProvider";
import "../Hotel/HotelTicketScreen.scss";
// import { PDFViewer } from "@react-pdf/renderer";
// import FlightDoc from "../../PdfDocuments/Flight/FlightDoc";
const { Option } = Select;
const { Panel } = Collapse;
const CheckboxGroup = Checkbox.Group;

const flightModalCloseIcon = (
  <CloseOutlined className="hotel-ticket-modal__close-icon" />
);

const FlightTicketScreen = ({ mode }) => {
  const {
    user,
    isLogin: { agent },
  } = useAuthContext();
  const ticketSearchParams = queryString.parse(window.location.search);
  const [cmsFareRules, setCmsFareRules] = useState({});
  const [loading, setLoading] = useState(false);
  const [cancellationType, setCancellationType] = useState(1);
  const { agentLogo, logo } = useSytContext();
  const [logoImage, setLogoImage] = useState(logo);
  const [ticketData, setTicketData] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [loadingTicket, setLoadingTicket] = useState(true);
  const BASE = process.env.REACT_APP_BASE_URL;
  const [form] = Form.useForm();
  useEffect(() => {
    getTicketDetails();
  }, []);
  const [fareRulesResp, setFareRulesResp] = useState();

  const disabledPrevDates = (currentDate) => {
    return currentDate < dayjs();
  };

  const fetchFareRules = (traceId) => {
    if (traceId)
      APIClient.get(`flights/getRulesFromTraceId/${traceId}`)
        .then((resp) => {
          if (resp.statusCode === 200 && resp?.data?.fareRules) {
            setFareRulesResp(resp.data);
          } else {
            let error_resp = {
              fareRules: [
                {
                  ruleDetails: "Fare Rules not Available",
                },
              ],
            };
            setFareRulesResp(error_resp);
          }
        })
        .catch((err) => console.log(err));
  };

  const getReleasePNR = (referenceId) => {
    const params = queryString.parse(document.location.search);
    if (params.ref && params.ref.indexOf("SYT-F") != -1) {
     
      referenceId=params.ref;
    } 
    if (referenceId)
      APIClient.get(`flights/airBookRelease/${referenceId}`)
        .then((resp) => {
          if (resp.statusCode === 200) {
            notification.success({
              message: 'Success',
              description: 'Your Ticket has been Released Successfully',
            });
            getTicketDetails();
          } else {
            notification.error({
              message:'Error',
              description: resp?.message || "The flight cannot be released. Please contact our internal support team."})
          }
        })
        .catch((err) => console.log(err));
  };

  const syncHoldReleaseFromProvider = (ref) => {
    if (!ref || ref.indexOf("SYT-F") === -1) return;
    APIClient.get(`flights/syncHoldRelease/${ref}`)
      .then((resp) => {
        if (resp?.released) {
          getTicketDetails();
        }
      })
      .catch(() => {});
  };

  
  const handleRelease = () => {
    setIsModalVisible(true);
    setIsChecked(false);
  };
  const CancelhandlePNR = () => {
    setIsModalVisible(false);
    setIsChecked(false);
  };
  const handleSubmit = () => {
    if (isChecked) {
      getReleasePNR();
      setIsModalVisible(false);
      setIsChecked(false); // Reset the checkbox
   
    } else {
      notification.warning({
        message: 'Warning',
        description: 'Please confirm by checking the box',
      });
    }
  };
   
  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };
  const mapDataToTicket = (data) => {
    setTicketData({
      ...data,
      source: data.oneWaySegment[0].origin,
      destination:
        data.oneWaySegment[data.oneWaySegment.length - 1].destination,
    });
    getCmsFareRules(data);
    setLoadingTicket(false);
  };

  useEffect(() => {
    if (agent && agentLogo) {
      setLogoImage(agentLogo);
    }
  }, [agent, agentLogo]);

  const getTicketDetails = () => {
    setLoadingTicket(true);
    APIClient.get("admin/myBookings/details", {
      travelType: "1",
      id: ticketSearchParams.ref,
    })
      .then((res) => {
        if (res.statusCode === 200) {
          fetchFareRules(res.data[0].traceId);

          if (mode === "USER") {
            let userId = user?.UserID ?? 1;
            if (res.data[0].UserId === userId) {
              mapDataToTicket(res.data[0]);
              if (
                res.data[0]?.BookingStatus === "HOLD" &&
                ticketSearchParams.ref
              ) {
                syncHoldReleaseFromProvider(ticketSearchParams.ref);
              }
            } else {
              setTicketData({});
              setLoadingTicket(false);
            }
          } else {
            mapDataToTicket(res.data[0]);
            if (
              res.data[0]?.BookingStatus === "HOLD" &&
              ticketSearchParams.ref
            ) {
              syncHoldReleaseFromProvider(ticketSearchParams.ref);
            }
          }
        } else {
          setTicketData({});
          setLoadingTicket(false);
        }
      })
      .catch((error) => {
        setTicketData({});

        setLoadingTicket(false);
      });
  };

  const flightCancelTicket = () => {
    setCancellationType(1);
    setModalVisible(true);
    form.resetFields();
  };

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const submitCancelForm = (val) => {
    let pnr = "";
    let returnPnr = "";

    if (ticketData.tripType === "oneWay" || ticketData.tripType === "OneWay") {
      pnr = ticketData.pnr;
    } else {
      let pnrArray = ticketData.pnr ? ticketData.pnr.split("~") : [];
      if (pnrArray.length > 0) {
        pnr = pnrArray[0];
        returnPnr = pnrArray[1];
      }
    }

    if (val.CancellationType === 1) {
      let passangers = ticketData.passengers.map((item) => ({
        title: item.title,
        firstName: item.firstName,
        lastName: item.lastName,
        passangerId: item.passangerId,
        ticketNumber: "string",
      }));

      let onwardSegments = ticketData.oneWaySegment.map((item) => ({
        ...item,
        Passangers: passangers,
      }));

      let returnSegments = ticketData.returnSegment.map((item) => ({
        ...item,
        Passangers: passangers,
      }));

      let req = {
        CancellationType: val.CancellationType,
        ReferenceNumber: ticketData.referenceNumber,
        PNR: pnr,
        guestEmailId: ticketData.guestEmaiId,
        guestMobileNo: ticketData.guestMobileNo,
        ReturnPNR: returnPnr,
        Segments: [...onwardSegments, ...returnSegments],
        Remarks: val.Remarks,
      };

      cancelApiCall(req);
    } else {
      let passangers = val.Passangers.map((item) => ({
        title: item.title,
        firstName: item.firstName,
        lastName: item.lastName,
        passangerId: item.passangerId,
        ticketNumber: "string",
      }));

      let segments = val.Segments.map((item) => ({
        ...item,
        Passangers: passangers,
      }));
      if (val.CancellationType === 2) {
        let req = {
          CancellationType: val.CancellationType,
          ReferenceNumber: ticketData.referenceNumber,
          PNR: pnr,
          guestEmailId: ticketData.guestEmaiId,
          guestMobileNo: ticketData.guestMobileNo,
          ReturnPNR: returnPnr,
          Segments: segments,
          Remarks: val.Remarks,
        };

        cancelApiCall(req);
      } else {
        let resheduleReq = {
          UserID: 0,
          PNR: pnr,
          ReturnPNR: returnPnr,
          guestEmailId: ticketData.guestEmaiId,
          guestMobileNo: ticketData.guestMobileNo,
          ReferenceNumber: ticketData.referenceNumber,
          RescheduleType: 1,
          RescheduleTripType:
            ticketData.tripType === "oneWay" || ticketData.tripType === "OneWay"
              ? 0
              : 1,
          Segments: segments,
          RescheduleDate: val.ReSheduleDate,
          RescheduleStatus: 1,
          Remarks: val.Remarks,
          CreatedBy: 0,
          ModifiedBy: 0,
        };
        resheduleApiCall(resheduleReq);
      }
    }
  };

  const cancelApiCall = (req) => {
    setLoading(true);
    APIClient.post("admin/airCancelRequest", req)
      .then((res) => {
        setLoading(false);
        if (res.statusCode == 200) {
          if (!!res.message) message.success(res.message, 10);

          getTicketDetails();
          setModalVisible(false);

          form.resetFields();
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const getCmsFareRules = (data) => {
    if (data) {
      let obj = {
        airlineCode: data?.oneWaySegment[0]?.flightCode,
        fareType: data?.coupanType,
        roleID: user?.Role?.RoleId ?? 4,
        membershipID: user?.Membership ?? 1,
      };
      APIClient.get("admin/getFlightFareRules", obj)
        .then((res) => {
          if (res.status == 200) {
            setCmsFareRules(res.data);
          } else {
            setCmsFareRules({});
          }
        })
        .catch((e) => {
          setCmsFareRules({});
        });
    }
  };

  const resheduleApiCall = (req) => {
    setLoading(true);

    APIClient.post("admin/airRescheduleRequest", req)
      .then((res) => {
        setLoading(false);
        if (res.statusCode == 200) {
          if (!!res.message) message.success(res.message, 10);
          getTicketDetails();
          setModalVisible(false);

          form.resetFields();
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  return (
    <div className="flight-ticket-collapse">
      <div className="d-flex justify-content-between">
        <div className="print-agentlogo">
          {logoImage ? (
            <Image
              className="printImageStyle"
              src={BASE + logoImage.substring(1)}
            ></Image>
          ) : (
            <Image className="printImageStyle" src={LogoImg}></Image>
          )}
        </div>
        <div className="print-agentlogo">
          {ticketData?.agentDetails ? (
            <div>
              <p className="mb-0 text-right">
                {ticketData?.agentDetails?.AgencyName}{" "}
              </p>
              <p className="mb-0 text-right">
                {ticketData?.agentDetails?.Address1}{" "}
                {ticketData?.agentDetails?.Address2}
              </p>
              {ticketData?.agentDetails?.City ||
              ticketData?.agentDetails?.State ? (
                <p className="mb-0 text-right">
                  {ticketData?.agentDetails?.City}{" "}
                  {ticketData?.agentDetails?.State}
                </p>
              ) : null}

              <p className="mb-0 text-right">
                Email: {ticketData?.agentDetails?.Email}
              </p>
              {ticketData?.agentDetails?.Phone ? (
                <p className="mb-0 text-right">
                  Contact No.: {ticketData?.agentDetails?.Phone}
                </p>
              ) : null}
            </div>
          ) : ticketData?.adminDetails?.length > 0 ? (
            <div>
              <p className="mb-0 text-right">
                {ticketData?.adminDetails[0]?.Address}{" "}
              </p>
              <p className="mb-0 text-right">
                {ticketData?.adminDetails[0]?.CityName}{" "}
                {ticketData?.adminDetails[0]?.StateName}
              </p>
              <p className="mb-0 text-right">
                {ticketData?.adminDetails[0]?.CountryName}{" "}
                {ticketData?.adminDetails[0]?.PostalCode}
              </p>
            </div>
          ) : null}
        </div>
      </div>

      <Card>
        <div className="fligh-ticket-container">
          {loadingTicket ? (
            <div style={{ textAlign: "center" }} className="flight-ticket">
              <Spin indicator={antIcon} tip="Loading..." />
            </div>
          ) : Object.keys(ticketData).length > 0 ? (
            <div className="flight-ticket">
              {/* <PDFViewer>
                <FlightDoc
                  ticketData={ticketData}
                  fareRulesResp={fareRulesResp}
                />
              </PDFViewer> */}
              <Row gutter={[32, 16]} className="ticket-row">
                <Col
                  md={shouldShowFlightTicketSidebar(ticketData) ? 17 : 24}
                  xs={24}
                  className="ticket-coloum "
                >
                  <TicketFlight
                    ticketData={ticketData}
                    fareRulesResp={fareRulesResp}
                    cmsFareRules={cmsFareRules}
                  />
                </Col>

                {shouldShowFlightTicketSidebar(ticketData) ? (
                <Col xs={24} md={7} className="tic-info-flight">
                  <div className="web-tic-info">
                    <TicketSidebar
                      ticketData={ticketData}
                      type="Flight"
                      onCancelTicket={flightCancelTicket}
                      getTicketDetails={getTicketDetails}
                      fareRulesResp={fareRulesResp}
                      cmsFareRules={cmsFareRules}
                      logoImage={logoImage}
                      GetReleasePnr={handleRelease}
                    />
                  </div>

                  <div className="mobile-tic-info">
                    <Collapse accordion>
                      <Panel header="Manage Tickets" key="1">
                        <TicketSidebar
                          ticketData={ticketData}
                          type="Flight"
                          onCancelTicket={flightCancelTicket}
                          getTicketDetails={getTicketDetails}
                          fareRulesResp={fareRulesResp}
                          cmsFareRules={cmsFareRules}
                          logoImage={logoImage} 
                          GetReleasePnr={handleRelease}
                        />
                      </Panel>
                    </Collapse>
                  </div>
                </Col>
                ) : null}
              </Row>
            </div>
          ) : (
            <p>No Ticket Found</p>
          )}
        </div>
      </Card>

      <Modal
        title="Cancel Ticket"
        className="promo-modal-header hotel-cancel-modal hotel-ticket-modal"
        closeIcon={flightModalCloseIcon}
        visible={modalVisible}
        onOk={(e) => setModalVisible(false)}
        onCancel={(e) => setModalVisible(false)}
        footer={[
          <div key="cancel-ticket-footer" className="hotel-cancel-modal__footer">
            {Object.keys(ticketData).length > 0 &&
            ticketData?.BookingStatus === "CANCELLED" ? null : (
              <Button
                key="add"
                type="primary"
                onClick={form.submit}
                loading={loading}
              >
                {cancellationType === 3 ? "Send Request" : "Cancel Ticket"}
              </Button>
            )}
          </div>,
        ]}
        width={"800px"}
      >
        <div className="wrapper">
          {Object.keys(ticketData).length > 0 &&
          ticketData?.BookingStatus !== "CANCELLED" ? (
            <Form
              layout="vertical"
              initialValues={{
                CancellationType: 1,
              }}
              form={form}
              onFinish={submitCancelForm}
            >
              <Row gutter={12}>
                <Col md={8} sm={12} xs={24}>
                  <Form.Item
                    label="Trip Cancellation Type"
                    name="CancellationType"
                    rules={[
                      { required: true, message: "Please Cancellation Type" },
                    ]}
                  >
                    <Select
                      placeholder="Select Cancellation Type"
                      onSelect={(val) => {
                        form.resetFields();
                        form.setFieldsValue({
                          CancellationType: val,
                        });
                        setCancellationType(val);
                      }}
                    >
                      <Option value={1}>Full Cancellation</Option>
                      <Option value={2}>Partial Cancellation</Option>
                      <Option value={3}>Change Itinerary / Reissue</Option>
                    </Select>
                  </Form.Item>
                </Col>

                {cancellationType === 1 ? (
                  <>
                    <Col md={8} sm={12} xs={24}>
                      <Form.Item label="Please Select Refund Sector">
                        <Row>
                          <Col md={24} sm={24}>
                            <Checkbox checked={true}>All </Checkbox>
                          </Col>

                          {ticketData.oneWaySegment.length > 0
                            ? ticketData?.oneWaySegment?.map((item, i) => (
                                <Col md={24} sm={24} key={i + "fullonseg"}>
                                  <Checkbox checked={true} disabled>
                                    {item.origin} - {item.destination} (
                                    {formatDate(item.departureDateTime,
                                      "DD MMM YYYY"
                                    )}
                                    )
                                  </Checkbox>
                                </Col>
                              ))
                            : null}
                          {ticketData.returnSegment.length > 0
                            ? ticketData?.returnSegment?.map((item, i) => (
                                <Col md={24} sm={24} key={i + "retsegfull"}>
                                  <Checkbox checked={true} disabled>
                                    {item.origin} - {item.destination} (
                                    {formatDate(item.departureDateTime,
                                      "DD MMM YYYY"
                                    )}
                                    )
                                  </Checkbox>
                                </Col>
                              ))
                            : null}
                        </Row>
                      </Form.Item>
                    </Col>
                    <Col md={8} sm={12} xs={24}>
                      <Form.Item label="Please Select Passanger">
                        <Row>
                          {ticketData?.passengers.map((item, i) => (
                            <Col md={24} sm={24} key={i + "modal"}>
                              <Checkbox checked={true} disabled>
                                <p className="mb-0">
                                  {i + 1}. {item.firstName} {item.lastName}
                                </p>
                              </Checkbox>
                            </Col>
                          ))}
                        </Row>
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col md={8} sm={12} xs={24}>
                      <Form.Item
                        label="Please Select Refund Sector"
                        name="Segments"
                        rules={[
                          {
                            required: true,
                            message: "Please Select Segment",
                          },
                        ]}
                      >
                        <CheckboxGroup>
                          <Row>
                            <Col md={24} sm={24}>
                              <Checkbox checked={false} disabled>
                                All{" "}
                              </Checkbox>{" "}
                            </Col>

                            {ticketData.oneWaySegment.length > 0
                              ? ticketData?.oneWaySegment?.map((item, i) => (
                                  <Col md={24} sm={24} key={i + "onseg"}>
                                    <Checkbox value={item}>
                                      {item.origin} - {item.destination} (
                                      {formatDate(item.departureDateTime,
                                        "DD MMM YYYY"
                                      )}
                                      )
                                    </Checkbox>
                                  </Col>
                                ))
                              : null}
                            {ticketData.returnSegment.length > 0
                              ? ticketData?.returnSegment?.map((item, i) => (
                                  <Col md={24} sm={24} key={i + "retseg"}>
                                    <Checkbox value={item}>
                                      {item.origin} - {item.destination} (
                                      {formatDate(item.departureDateTime,
                                        "DD MMM YYYY"
                                      )}
                                      )
                                    </Checkbox>
                                  </Col>
                                ))
                              : null}
                          </Row>
                        </CheckboxGroup>
                      </Form.Item>
                    </Col>
                    <Col md={8} sm={12} xs={24}>
                      <Form.Item
                        label="Please Select Passanger"
                        name="Passangers"
                        rules={[
                          {
                            required: true,
                            message: "Please Select Passanger",
                          },
                        ]}
                      >
                        <CheckboxGroup>
                          <Row>
                            {ticketData?.passengers.map((item, i) => (
                              <Col md={24} sm={24} key={i + "modal"}>
                                <Checkbox value={item}>
                                  {i + 1}. {item.firstName} {item.lastName}
                                </Checkbox>
                              </Col>
                            ))}
                          </Row>
                        </CheckboxGroup>
                      </Form.Item>
                    </Col>
                  </>
                )}
                {cancellationType === 3 ? (
                  <Col md={8} sm={12} xs={24}>
                    <Form.Item
                      label="Reschedule Date:"
                      name="ReSheduleDate"
                      rules={[
                        { required: true, message: " " },
                        {
                          validator: OnlyFutureDateValidator,
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        disabledDate={disabledPrevDates}
                      />
                    </Form.Item>
                  </Col>
                ) : null}

                <Col md={24} sm={24} xs={24}>
                  <Form.Item
                    label="Please  Enter Remarks"
                    name="Remarks"
                    rules={[
                      {
                        required: true,
                        message: "Required",
                      },
                    ]}
                  >
                    <Input.TextArea rows={2} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          ) : null}
          {cancellationType !== 3 ? (
            <div className="note-wrapper mt-3">
              <h6>Note: </h6>
              <ol className="pl-0">
                <li>1. Partial Refund will be processed offline.</li>
                <li>
                  2. In case of Infant booking, cancellation will be processed
                  offline.
                </li>
                <li>
                  3. In case of One sector to be cancel, please send the offline
                  request.
                </li>
                <li>
                  4. In case of Flight cancelation/ flight reschedule, please
                  select flight cancelled.
                </li>
                <li>
                  5. Cancellation Charges cannot be retrieved for Partial
                  Cancelled Booking
                </li>
              </ol>
            </div>
          ) : null}
        </div>
      </Modal>
      <Modal
        title="Release PNR"
        className="promo-modal-header hotel-ticket-modal"
        closeIcon={flightModalCloseIcon}
        visible={isModalVisible}
        onOk={handleSubmit}
        onCancel={() => CancelhandlePNR()}
        footer={[
          <div key="release-pnr-footer">
            <Button key="back" onClick={CancelhandlePNR}>
              Cancel
            </Button>
            <Button key="submit" type="primary" onClick={handleSubmit}>
              Submit
            </Button>
          </div>,
        ]}
      >
        <Checkbox checked={isChecked} onChange={handleCheckboxChange}>
          Are you sure you want to release this PNR?
        </Checkbox>
      </Modal>
      
    </div>
  );
};

export default FlightTicketScreen;
